module.exports = __webpack_public_path__ + "static/media/liam.45ed2039.jpg";